import Axios from 'axios'


export default {
  url: 'https://k-pt.sakura.ne.jp/backend',
  candiUrl: 'https://k-pt.sakura.ne.jp/candiPhoto',
  // AUTHのみで利用する
  setAxios () {
    var axios = Axios.create({
      baseURL: this.url,
      headers: {// 'Content-Type': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest' },
      responseType: 'json' })
    return axios
  },
  // ログインチェック用
  async loginCheck (jwt, vue) {
    var axios = Axios.create({
      baseURL: this.url,
      headers: {// 'Content-Type': 'application/json',
        'Authorization': 'bearer ' + jwt,
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest' },
      responseType: 'json' })
    var res
    res = await axios.get('/auth_check.php')
    if (res.data.ret === -1) {
      vue.$router.push({name: 'login'})
    }
  },
  // getのラッパー
  // 認証エラーの場合はログインへ
  get (vue, url, params = null, func) {
    var axios = Axios.create({
      baseURL: this.url,
      headers: {// 'Content-Type': 'application/json',
        'Authorization': 'bearer ' + vue.$jwt.getToken(),
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest' },
      responseType: 'json' })
    axios.get(url, {params: params}).then(function (res) {
      if (res.ret === -1) {
        vue.$router.push({name: 'login'})
      } else {
        func(res)
      }
    })
  },
  // POST のラッパー
  // 認証エラーはログインへ
  post (vue, url, params = null, func) {
    console.log(params)
    var qs = require('qs')
    var axios = Axios.create({
      baseURL: this.url,
      headers: {// 'Content-Type': 'application/json',
        'Authorization': 'bearer ' + vue.$jwt.getToken(),
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest' },
      responseType: 'json' })
    axios.post(url, qs.stringify(params)).then(function (res) {
      if (res.ret === -1) {
        vue.$router.push({name: 'login'})
      } else {
        func(res)
      }
    })
  },
  upload (vue, url, params = null, func) {
    var axios = Axios.create({
      baseURL: this.url,
      headers: {// 'Content-Type': 'application/json',
        'Authorization': 'bearer ' + vue.$jwt.getToken(),
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest' },
      responseType: 'json' })
    axios.post(url, params, {headers: {'content-type': 'multipart/form-data'}}).then(function (res) {
      if (res.ret === -1) {
        vue.$router.push({name: 'login'})
      } else {
        func(res)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/axios/ax.js